var hexRegex = /^#([a-fA-F0-9]{3}){1,2}$/;
/**
 * Converts HEX color to RGBA counterpart, with optional alpha setting
 */

var hexToRgbaColor = function hexToRgbaColor(hexColor) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  if (!hexRegex.test(hexColor)) {
    throw new Error("Couldn't parse the color string. Please provide the color as a string in HEX notation.");
  }

  var value = hexColor.slice(1);
  var group = value.length / 3;
  return "rgba(".concat([0, 1, 2].map(function (i) {
    return value.slice(i * group, (i + 1) * group);
  }).map(function (v) {
    return parseInt((v + v).slice(-2), 16).toString();
  }).concat(alpha.toString()).join(', '), ")");
};

export default hexToRgbaColor;